/* JAYKEI product page: auto-sliding gallery, thumbnails, tabs, quantity,
   and variant resolution when a real product is attached. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var stage = root.querySelector('[data-pdp-stage]');
    var dotsBox = root.querySelector('[data-pdp-dots]');
    var thumbsBox = root.querySelector('[data-pdp-thumbs]');
    if (!stage) return;

    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-pdp-slide]'));
    if (slides.length < 1) return;

    var index = 0;
    var timer = null;
    // stored in seconds on the section, 0 means "do not auto-slide"
    var interval = (parseFloat(root.dataset.autoplay) || 0) * 1000;

    // Dots and thumbnails are built here rather than in Liquid so they can never
    // disagree with the number of slides actually rendered.
    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jk-pdp__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () { go(i, true); });
      if (dotsBox) dotsBox.appendChild(b);
      return b;
    });

    var thumbs = slides.map(function (slide, i) {
      var src = slide.querySelector('img');
      if (!src || !thumbsBox) return null;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jk-pdp__thumb';
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      var im = document.createElement('img');
      im.src = src.currentSrc || src.src;
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () { go(i, true); });
      thumbsBox.appendChild(b);
      return b;
    });

    function go(next, userDriven) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      if (dots[index]) dots[index].setAttribute('aria-selected', 'false');
      if (dots[next]) dots[next].setAttribute('aria-selected', 'true');
      if (thumbs[index]) thumbs[index].setAttribute('aria-current', 'false');
      if (thumbs[next]) thumbs[next].setAttribute('aria-current', 'true');
      index = next;
      // A tap means the visitor is steering; don't yank the slide away from them.
      if (userDriven) restart();
    }

    function tick() { go((index + 1) % slides.length, false); }
    function restart() {
      window.clearInterval(timer);
      if (interval > 0 && slides.length > 1 && !reduced) timer = window.setInterval(tick, interval);
    }

    restart();
    // let the variant picker drive the gallery: choosing a colour jumps to the
    // slide whose image is that variant's featured image
    root.jkGalleryGoToSrc = function (src) {
      if (!src) return false;
      // filename only - the two sources sit on different hosts
      var key = String(src).split('?')[0].split('/').pop();
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaSrc === key) { go(i, true); return true; }
      }
      return false;
    };
    stage.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    stage.addEventListener('mouseleave', restart);
    // Nothing to animate while the section is off screen, and a background tab
    // should not keep cycling either.
    document.addEventListener('visibilitychange', function () {
      document.hidden ? window.clearInterval(timer) : restart();
    });
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-panel]'));
    if (!tabs.length) return;

    function select(i) {
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length;
        tabs[n].focus();
        select(n);
      });
    });
  }

  /* ---------- quantity ---------- */
  function initQty(root) {
    var input = root.querySelector('[data-pdp-qty]');
    if (!input) return;
    function nudge(by) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      input.value = Math.max(1, v + by);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var up = root.querySelector('[data-pdp-qty-up]');
    var down = root.querySelector('[data-pdp-qty-down]');
    if (up) up.addEventListener('click', function () { nudge(1); });
    if (down) down.addEventListener('click', function () { nudge(-1); });
  }

  /* ---------- variants ---------- */
  function initVariants(root) {
    var holder = document.querySelector('[data-pdp-variants]');
    var idField = root.querySelector('[data-pdp-variant-id]');
    if (!holder || !idField) return;   // preview mode has no real variants

    var variants;
    try { variants = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var priceEl = root.querySelector('[data-pdp-price]');
    var stockEl = root.querySelector('[data-pdp-stock]');
    var skuEl = root.querySelector('[data-pdp-sku]');
    var addBtn = root.querySelector('.jk-pdp__btn--cart');
    var buyBtn = root.querySelector('.jk-pdp__btn--buy');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
    if (!inputs.length) return;

    var money = (window.Shopify && Shopify.formatMoney) ? null : null;

    function chosen() {
      var out = [];
      inputs.forEach(function (i) {
        if (i.checked) out[parseInt(i.dataset.position, 10) - 1] = i.value;
      });
      return out;
    }

    function apply() {
      var want = chosen();
      var match = null;
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < want.length; o++) {
          if (want[o] && variants[v].options[o] !== want[o]) { ok = false; break; }
        }
        if (ok) { match = variants[v]; break; }
      }
      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      idField.value = match.id;
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (priceEl && typeof match.price === 'number') {
        // Shopify serves prices in cents; keep the shop's own currency symbol
        // by reusing whatever is already rendered.
        var symbol = (priceEl.textContent.match(/^[^\d]*/) || [''])[0];
        var amount = (match.price / 100);
        priceEl.textContent = symbol + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
      }
      if (stockEl) {
        stockEl.textContent = match.available ? (stockEl.dataset.inLabel || stockEl.textContent)
                                              : (stockEl.dataset.outLabel || 'OUT OF STOCK');
        stockEl.classList.toggle('jk-pdp__stock--out', !match.available);
      }
      if (addBtn) addBtn.disabled = !match.available;
      if (buyBtn) buyBtn.disabled = !match.available;

      // jump the gallery to this variant's own photo
      var vimg = match.featured_image && match.featured_image.src;
      if (vimg && typeof root.jkGalleryGoToSrc === 'function') root.jkGalleryGoToSrc(vimg);

      // Keep the URL shareable without reloading the page.
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }

    // Grey out option values that cannot be bought with the current selection,
    // so a sold-out size reads the way Figma draws it rather than silently
    // failing on submit.
    function markAvailability() {
      var current = chosen();
      inputs.forEach(function (input) {
        var pos = parseInt(input.dataset.position, 10) - 1;
        var trial = current.slice();
        trial[pos] = input.value;
        var ok = variants.some(function (v) {
          if (!v.available) return false;
          for (var o = 0; o < trial.length; o++) {
            if (trial[o] && v.options[o] !== trial[o]) return false;
          }
          return true;
        });
        var label = input.closest('label');
        if (label) label.classList.toggle('is-sold', !ok);
        input.disabled = !ok && !input.checked;
      });
    }

    // Clicking the colour that is already selected fires no 'change', so the
    // gallery would sit wherever auto-slide had drifted to. Re-jump on click too.
    function jumpToCurrent() {
      var want = chosen();
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < want.length; o++) {
          if (want[o] && variants[v].options[o] !== want[o]) { ok = false; break; }
        }
        if (ok && variants[v].featured_image && typeof root.jkGalleryGoToSrc === 'function') {
          root.jkGalleryGoToSrc(variants[v].featured_image.src);
          return;
        }
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { apply(); markAvailability(); });
      i.addEventListener('click', jumpToCurrent);
    });
    apply();
    markAvailability();
  }

  function init() {
    document.querySelectorAll('[data-jk-pdp]').forEach(function (root) {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      initGallery(root);
      initTabs(root);
      initQty(root);
      initVariants(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
